import { render, staticRenderFns } from "./assign-to-user-form.vue?vue&type=template&id=c262681c&scoped=true&"
import script from "./assign-to-user-form.vue?vue&type=script&lang=js&"
export * from "./assign-to-user-form.vue?vue&type=script&lang=js&"
import style0 from "./assign-to-user-form.vue?vue&type=style&index=0&id=c262681c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c262681c",
  null
  
)

export default component.exports